import React from 'react';
import AudioPlayer from './AudioPlayer';
import ExamQuestion from './ExamQuestion';

const ExamHoerenContent = ({
  task,
  answers,
  submitted,
  resultDetails,
  onAnswer,
  questionStartIndex,
  showTranscript,
  onToggleTranscript,
}) => {
  let qNum = questionStartIndex;

  return (
    <div className="exam-teil-block">
      <h2 className="exam-teil-heading">Teil {task.teil}</h2>
      <p className="exam-instruction">{task.instruction}</p>

      <div className="border border-gray-500 p-3 mb-4 bg-gray-50 font-sans">
        {task.audioUrl ? (
          <AudioPlayer audioUrl={task.audioUrl} script={task.audioScript} label="Offizielles Hören-Audio" />
        ) : task.audioSegments?.length > 0 ? (
          <div className="space-y-3">
            {task.audioSegments.map((seg) => (
              <div key={seg.id}>
                <p className="text-[10px] font-bold uppercase mb-1">{seg.label}</p>
                <AudioPlayer script={seg.script} />
              </div>
            ))}
          </div>
        ) : (
          <AudioPlayer script={task.audioScript} />
        )}
        <button
          type="button"
          onClick={onToggleTranscript}
          className="mt-3 text-[10px] font-bold uppercase tracking-wide text-brand-text/70 hover:text-black"
        >
          {showTranscript ? '− Transkript ausblenden' : '+ Transkript (Übung)'}
        </button>
        {showTranscript && (
          <pre className="mt-2 text-[11px] whitespace-pre-wrap border-t border-gray-300 pt-2 text-brand-text/80 max-h-48 overflow-y-auto">
            {task.audioScript}
          </pre>
        )}
      </div>

      {task.speakers?.length > 0 && (
        <p className="text-xs mb-3 font-sans">
          <strong>Wer sagt das?</strong>{' '}
          {task.speakers.map((s) => (
            <span key={s.id} className="mr-3">
              <strong>{s.label}</strong> {s.name}
            </span>
          ))}
        </p>
      )}

      <div className="border-t border-gray-400 pt-3">
        {task.questions?.map((q) => {
          qNum += 1;
          return (
            <ExamQuestion
              key={q.id}
              question={q}
              task={task}
              index={qNum}
              answers={answers}
              submitted={submitted}
              resultDetails={resultDetails}
              onAnswer={onAnswer}
            />
          );
        })}
      </div>
    </div>
  );
};

export default ExamHoerenContent;
